<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      size="normal"
      :visible.sync="modalVisible"
      :confirmLoading="confirmLoading"
      >
    <template #header>归档</template>
    <template #content>
      <div class="warning-content">
        <div class="warning-content--icon"><i class="el-icon-warning"></i></div>
        <div class="warning-content--title">是否确认归档？</div>
        <div class="warning-content--detail">
          归档后亚马逊会<span class="danger-text">删除</span>这些活动，不能再开启，<span class="danger-text">此操作不可逆</span>，请谨慎操作！
        </div>
      </div>
    </template>
  </gj-modal>
</template>

<script>
  import {modalMixIn} from "../../../../../../minxins";

  export default {
    name: "app-archive-warning-modal",
    mixins: [modalMixIn],
    data() {
      return {
        confirmLoading: false
      }
    }
  }
</script>

<style scoped>
  .warning-content {
    text-align: center;
  }
  .warning-content--icon {
    font-size: 90px;
    line-height: normal;
    color: #FAAD14;
  }
  .warning-content--title {
    margin: 5px 0 20px;
    color: #27274B;
    font-weight: bold;
    font-size: 20px;
  }
  .warning-content--detail {
    font-size: 13px;
    color: #8D8D8D;
  }
  .danger-text {
    color: red;
    font-weight: bold;
  }
</style>
